/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'
import Body20 from '../model/Body20'
import InlineResponse2002 from '../model/InlineResponse2002'

/**
 * CheckIn service.
 * @module api/CheckInApi
 * @version 1.0.0
 */
export default class CheckInApi {
  /**
   * Constructs a new CheckInApi.
   * @alias module:api/CheckInApi
   * @class
   * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  constructor(apiClient) {
    this.apiClient = apiClient || ApiClient.instance
  }

  /**
   * チェックインを削除(パスポート画像は削除されない)
   * @param {Number} reservationId Target reservation id.
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
   */
  deleteCheckInWithHttpInfo(reservationId) {
    let postBody = null

    // verify the required parameter 'reservationId' is set
    if (reservationId === undefined || reservationId === null) {
      throw new Error("Missing the required parameter 'reservationId' when calling deleteCheckIn")
    }

    let pathParams = {
      reservation_id: reservationId
    }
    let queryParams = {}
    let headerParams = {}
    let formParams = {}

    let authNames = ['Bearer']
    let contentTypes = ['application/json']
    let accepts = ['application/json']
    let returnType = null

    return this.apiClient.callApi('/check_in/{reservation_id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType)
  }

  /**
   * チェックインを削除(パスポート画像は削除されない)
   * @param {Number} reservationId Target reservation id.
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}
   */
  deleteCheckIn(reservationId) {
    return this.deleteCheckInWithHttpInfo(reservationId).then(function(response_and_data) {
      return response_and_data.data
    })
  }

  /**
   * Search CheckIn
   * @param {module:model/Body20} body
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InlineResponse2002} and HTTP response
   */
  searchCheckInWithHttpInfo(body) {
    let postBody = body

    // verify the required parameter 'body' is set
    if (body === undefined || body === null) {
      throw new Error("Missing the required parameter 'body' when calling searchCheckIn")
    }

    let pathParams = {}
    let queryParams = {}
    let headerParams = {}
    let formParams = {}

    let authNames = ['Bearer']
    let contentTypes = ['application/json']
    let accepts = ['application/json']
    let returnType = InlineResponse2002

    return this.apiClient.callApi('/check_in/search', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType)
  }

  /**
   * Search CheckIn
   * @param {module:model/Body20} body
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InlineResponse2002}
   */
  searchCheckIn(body) {
    return this.searchCheckInWithHttpInfo(body).then(function(response_and_data) {
      return response_and_data.data
    })
  }
}
